//@ts-check
import {Button, Text} from '@/components-v2/atoms'
import {TextInput} from '@/components-v2/molecules'
import {useComboSubCategories} from '@/hooks/productCombo/useComboSubCategories'

export const ComboSubCategories = () => {
  const {
    languages,
    subCategories,
    isAddSubCategoryDisabled,
    handleAddSubCategory,
    handleRemoveSubCategory,
    handleSubCategoryCodeChange,
    handleSubCategoryNameChange,
  } = useComboSubCategories()

  return (
    <div className="flex flex-col gap-4">
      {subCategories.map((subCategory, index) => (
        <div
          key={`combo-subcategory-${index}`}
          className="flex flex-col gap-4 border-b border-[var(--secondary-800)] pb-4"
        >
          <div className="flex items-end justify-between gap-4">
            <TextInput
              id={`combo-subcategory-id-${index}`}
              label="Subcategory ID"
              placeholderText="Enter subcategory ID"
              value={subCategory.code}
              onUpdate={value => handleSubCategoryCodeChange(index, value)}
              required
              maxLength={255}
            />
            <Button variant="tertiary" size="medium" onClick={() => handleRemoveSubCategory(index)}>
              Delete Subcategory
            </Button>
          </div>
          <div className="grid grid-cols-3 gap-4">
            {languages.map(language => (
              <div key={`${index}-${language.code}`} className="flex flex-col gap-2">
                <Text variant="medium">{language.language}</Text>
                <TextInput
                  id={`combo-subcategory-${index}-${language.code}`}
                  label="Subcategory Name"
                  placeholderText="Enter subcategory name"
                  value={subCategory.values?.[language.code] || ''}
                  onUpdate={value => handleSubCategoryNameChange(index, language.code, value)}
                  required
                  maxLength={255}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
      <div className="flex items-center justify-between">
        <Button
          variant="tertiary"
          size="medium"
          iconLeading="add_box"
          disabled={isAddSubCategoryDisabled}
          className={isAddSubCategoryDisabled ? 'opacity-25' : ''}
          onClick={handleAddSubCategory}
        >
          Add Subcategory
        </Button>
      </div>
    </div>
  )
}
